import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";

const DownloadFile = ({ type, isLoading = false, disabled = false }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownloadData = () => {
    setIsDownloading(true);
    axios
      .get(`/report/url/${type}`)
      .then((response) => {
        //rpl, student, insurance, client, skill, visa
        const a = document.createElement("a");

        const blobFile = new Blob([response?.data], {
          type: "application/octet-stream",
        });
        const url = response.data.url;
        a.href = url;
        a.download = "Clients_Data.csv";
        a.click();
        window.URL.revokeObjectURL(url);
        setIsDownloading(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to download data");
        setIsDownloading(false);
      });
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={isDownloading ? <CircularProgress size={20} /> : <FaDownload />}
        onClick={handleDownloadData}
        disabled={isDownloading || disabled || isLoading}
      >
        Download Data
      </Button>
    </>
  );
};

export default DownloadFile;
